import React, { useState, useEffect } from 'react'
import { motion } from 'framer-motion';
import './index.css';

export const Welcome = () => {
    const text = '< ABIR / >';
    const [exit, setExit] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => {
            setExit(true);
        }, 3000);

        return () => clearTimeout(timer);
    }, []);
    return (
        <div className='Welcome'>

            {text.split('').map((letter, index) => (
                <motion.span
                    key={index}
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: 20 }}
                    transition={{ duration: 0.5, delay: index * 0.1 }}
                >
                    {letter}
                </motion.span>
            ))}

        </div>
    )
}
